import React from 'react';
import Reveal from '../ui/reveal';
import mouseTranslate from '../global/mouseTranslate';
import Button from '../ui/button';
import LazyBackground from '../ui/lazyBackground';
import * as timelineStyle from "./timeline.module.scss";
import * as style from './timelineBannerCallout.module.scss';

const TimelineBannerCallout = props => (
  <div>
    <div className={`${style.bannerCallout}`}>
      <div className={`reveal fadeInUp ${style.revealContainer}`}>
        <div className={style.imgWrap}>
          <div className={style.imgTransformer}>
            {props.src && (
              <LazyBackground
                src={props.src}
                hasRevealer={props.hasRevealer}
                revealed={props.revealed}
              />
            )}
          </div>
        </div>
      </div>
      <div className={`${style.contentWrap} ${timelineStyle.timelineBlock}`}>
        <div className={`fadeInBlur reveal reveal-delay-500`}>
          <div className="row">
            <div className="col-xs-12 col-lg-7 push-xs-1 push-lg-4">
              {props.label && (
                <p>
                  <span className="f-label">{props.label}</span>
                </p>
              )}
              <h2 className={style.bannerHeadline}>{props.callout_heading}</h2>
              <Button
                color="white"
                to={props.cta_link.url}
                text={props.cta_link.title}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default TimelineBannerCallout;
